import gql from "graphql-tag"

/* ========== No Results Properties ======== */
const NoResultProperties = gql`
query NoResultProperties($status: String!, $department: String!){
    properties(limit:6, where:{status:$status, department:$department, publish:true}) {
        id
        display_address
        search_type
        status
        slug
        title
        department
        price
        images
        crm_negotiator_id
        bedroom
        reception
        bathroom
        description
    }

}`
export const Queries = {
    NoResultProperties,
};
